<div class="modal-body width-500">
	<div class="layout-auto-1-auto">
		<span class="modal-header">
			{{getRessource('ModalTitle')}}
		</span>
		<div class="content height-700">
			<div class="grid-auto-1-auto" *ngFor="let sheet of data.sheets; let i = index;">
				<exg-switch name="{{sheet.sheetID}}"
				            style="align-self: start; overflow: visible; padding: 1rem 1rem 1rem 0;"

				            [(ngModel)]="sheet.sheetSelected">
				</exg-switch>
				<div (click)="sheet.sheetSelected = !sheet.sheetSelected">
					{{sheet.sheetName}}
				</div>
				<app-exg-select-enumeration [(value)]="sheet.sheetFolder"
				                            [disabled]="!data.showFolderSelection"
				                            listDisplay="enmText"
				                            [caption]="getRessource('Folder')"
				                            enumerationName="DokTyp"
				>
				</app-exg-select-enumeration>
			</div>
		</div>
		<div class="spawn-modal-actions">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()" class="md-btn"
							[class.disabled]="selectedCount === 0">
				{{data.showFolderSelection ? getGlobal('Save') : getGlobal('Download')}}
			</button>
		</div>
	</div>
</div>
